import React from 'react';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import DatePicker from '../../Components/Datepicker_Basic';
import FormGroup from '../../Components/Form_Group';
import Radio from '../../Components/Radio_Basic';
import AgDatePicker from '../../Components/agGrid/ag-DatePicker';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';
import Commons from '../../Services/Common/Common';

function PM10030(props) {
    React.useEffect(() => {
        document.title = '자재입고등록';

        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '구매관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>자재입고등록</strong>" +
            '</h1>';
    }, []);
    const gridRef = React.useRef();
    const columnDefs = [
        //진행상태
        {
            field: 'poStusNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PoSatusNm' && f.lanType === 'COL')[0].lanName
                    : '',
            cellRenderer: Commons.CustomHeaderRenderer,
        },
        //발주일자
        {
            field: 'poCreateDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ProcessOrderDate' && f.lanType === 'COL')[0].lanName
                    : '',
        }, //거래처코드
        {
            field: 'custCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustCd' && f.lanType === 'COL')[0].lanName
                    : '',
        },
        //거래처명
        {
            field: 'custNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustNm' && f.lanType === 'COL')[0].lanName
                    : '',
        },
        //참조
        {
            field: 'reference',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Reference' && f.lanType === 'COL')[0].lanName
                    : '',
        },
        //담당자
        {
            field: 'personCharg',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PersonCharg' && f.lanType === 'COL')[0].lanName
                    : '',
        },
        //발주번호
        {
            field: 'poNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PoNo' && f.lanType === 'COL')[0].lanName
                    : '',
        },
    ];
    const gridRef1 = React.useRef();
    const columnDefs1 = [
        {
            field: 'no',
            headerName: 'No',
            minWidth: 110,
            headerCheckboxSelection: true,
            checkboxSelection: true,
        },
        //진행상태
        {
            field: 'poStusNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PoSatusNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
            cellRenderer: Commons.CustomHeaderRenderer,
        },
        //창고
        {
            field: 'whNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WhNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 130,
            cellRenderer: Commons.CustomWhCdRenderer,
        },
        //입고일자
        {
            field: 'stockInDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_StockInDate' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
            suppressMovable: true,
            editable: (e) => (e.data.poStusNm === '입고완료' ? false : true),
        },
        //발주일자
        {
            field: 'poCreateDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ProcessOrderDate' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
        },

        // { field: "plantCd", headerName: "사업장코드" },

        //품목명
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 220,
        },
        //규격
        {
            field: 'itemStd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemStd1' && f.lanType === 'COL')[0].lanName
                    : '',
            cellStyle: { textAlign: 'center' },
            minWidth: 110,
        },
        {
            field: 'poAddItemQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PoItemQty' && f.lanType === 'COL')[0].lanName
                    : '', // 발주수량
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            aggFunc: 'sum',
            minWidth: 110,
        },
        {
            field: 'poItemQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PoItemBomQty' && f.lanType === 'COL')[0].lanName
                    : '', // 수량(BOM)
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            aggFunc: 'sum',
            minWidth: 110,
        },
        //입고수량
        {
            field: 'inQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_InQty' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: (e) => (e.data.poStusNm === '입고완료' ? false : true),
            minWidth: 110,
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '0';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            cellClass: 'numberType',
            aggFunc: 'sum',
        },
        //단위
        {
            field: 'itemUnit',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemUnit' && f.lanType === 'COL')[0].lanName
                    : '',
            cellStyle: { textAlign: 'right' },
            minWidth: 110,
        },
        //단가
        {
            field: 'inItemCost',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCost' && f.lanType === 'COL')[0].lanName
                    : '',
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '0';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            minWidth: 110,
            // aggFunc: "sum",
        },
        //단가(VAT포함)
        {
            field: 'poItemCost',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PoItemCost' && f.lanType === 'COL')[0].lanName
                    : '',
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '0';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            minWidth: 150,
            // aggFunc: "sum",
        },
        //공급가액
        {
            field: 'inItemAmt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PoItemAmt' && f.lanType === 'COL')[0].lanName
                    : '',
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '0';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            minWidth: 110,
            aggFunc: 'sum',
        },
        //부가세여부
        {
            field: 'itemVatYn',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemVatYn' && f.lanType === 'COL')[0].lanName
                    : '',
            cellStyle: { textAlign: 'center' },
            minWidth: 140,
        },
        //부가세
        {
            field: 'inItemVat',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemVat' && f.lanType === 'COL')[0].lanName
                    : '',
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '0';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            minWidth: 110,
            aggFunc: 'sum',
        },
        //적요
        {
            field: 'remark',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_RemarkDtl' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
        },
        //입고번호
        {
            field: 'stockInNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_StockInNo' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
        },
        // 품목코드
        {
            field: 'itemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCd' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
        },
        {
            field: 'createDate',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateDate' && f.lanType === 'COL')[0].lanName
                    : '', //생성일자
            minWidth: 100,
            editable: false,
        },
        {
            field: 'createId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateId' && f.lanType === 'COL')[0].lanName
                    : '', //생성자
            minWidth: 100,
            editable: false,
        },
        {
            field: 'updateDate',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UpdateDate' && f.lanType === 'COL')[0].lanName
                    : '', //수정일자
            minWidth: 200,
            minWidth: 100,
            editable: false,
        },
        {
            field: 'updateId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UpdateId' && f.lanType === 'COL')[0].lanName
                    : '', //수정자
            minWidth: 100,
            editable: false,
        },
    ];

    const onCellClicked = (e) => {
        const selected = e.data;
        props.SearchItemLogic(selected.poNo, selected.stockInNo);
        props.setInputs({
            ...props.inputs,
            custNm: selected.custNm,
            custCd: selected.custCd,
            stockInNo: selected.stockInNo,
            stockInDt: selected.stockInDt ? new Date(selected.stockInDt) : new Date(),
            createId: selected.createId,
            inWh: selected.inWh,
            poStusNm: selected.poStusNm,
            poNo: selected.poNo,
        });
    };

    return (
        <div
            style={{
                // display: "flex",
                flexDirection: 'row',
                justifyContent: 'space-evenly',
                alignItems: 'center',
            }}
        >
            <div style={{ width: '100%', height: '30%' }}>
                <Section />
                <Card
                    wrapStyle={{
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}
                >
                    {' '}
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        {props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Fom_StockInDate' && f.lanType === 'FORM')[0]
                                  .lanName
                            : ''}
                        <DatePicker
                            className={'datepicker-custom-input'}
                            style={{ width: '120px', marginRight: '5px' }}
                            selected={props.startDate}
                            onChange={(e) => {
                                props.setStartDate(e);
                            }}
                        />
                        ~
                        <DatePicker
                            className={'datepicker-custom-input'}
                            style={{ width: '120px', marginLeft: '5px' }}
                            selected={props.endDate}
                            onChange={(e) => {
                                props.setEndDate(e);
                            }}
                        />
                        {/* <Radio
              items={[
                { value: "All", name: "전체" },
                { value: "StockIn", name: "등록대상" },
              ]}
              value={props.selectedRadio}
              onChange={(e) => {
                props.setSelectedRadio(e.target.value);
              }}
            /> */}
                    </div>
                    <AuthGroupButton
                        pageName="PM10030"
                        target="G01"
                        refreshNone="none"
                        refreshFunc={() => {
                            // props.Init();
                        }}
                        selectFunc={() => {
                            props.SearchLogic();
                        }}
                        addFunc={() => props.setModalToggle(true)}
                        saveFunc={() => props.SaveConfirm()}
                        deleteFunc={() => props.DeleteConfirm()}
                    />
                </Card>
                <Section />
                <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '335px' }}>
                    <AgGridReact
                        ref={gridRef}
                        animateRows={true}
                        columnDefs={columnDefs}
                        defaultColDef={{
                            flex: 1,
                            editable: false,
                            resizable: true,
                            sortable: true,
                            filter: true,
                            floatingFilter: true,
                        }}
                        frameworkComponents={{
                            customHeaderRenderer: Commons.CustomHeaderRenderer,
                        }}
                        // onCellValueChanged={(e) =>
                        //   GridFunctions.onCellValueChanged(
                        //     e,
                        //     gridRef,
                        //     props.setChangedRowData
                        //   )
                        // }
                        rowData={props.rowData}
                        rowSelection="single"
                        onSelectionChanged={() => GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData)}
                        onCellClicked={onCellClicked}
                    />
                </div>
            </div>
            <div style={{ width: '100%', height: '50%' }}>
                {/* <div> */}
                {/* <Section /> */}
                {/* <Card
          wrapStyle={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <AuthGroupButton
            pageName="PM10030"
            target="F01"
            refreshNone="none"
            refreshFunc={() => {
              props.Reset();
              props.setSelectedRowData([]);
            }}
            addFunc={() => {
              props.Reset();
              props.setSelectedRowData([]);
            }}
            saveFunc={() => props.SaveConfirm("save")}
            deleteFunc={() => props.DeleteConfirm()}
          />
        </Card> */}
                {/* <Section />
          <Card style={{ height: "190px", marginTop: "0px" }}>
            <FormGroup
              columnCount={3}
              datas={[
                {
                  type: "input",
                  name: "거래처",
                  inputClass: "input",
                  value: props.inputs.custNm ? props.inputs.custNm : "",
                  onChange: (e) => {
                    let { value } = { ...e.target };
                    props.setInputs({
                      ...props.inputs,
                      custNm: value,
                    });
                  },
                  readOnly: true,
                },
                // {
                //   type: "input",
                //   name: "입고번호",
                //   inputClass: "input",
                //   value: props.inputs.stockInNo ? props.inputs.stockInNo : "",
                //   onChange: (e) => {
                //     let { value } = { ...e.target };
                //     props.setInputs({
                //       ...props.inputs,
                //       stockInNo: value,
                //     });
                //   },
                //   readOnly: true,
                // },
                {
                  type: "date",
                  name: "입고일자",
                  inputClass: "input",
                  inputBoxClass: "dd33",
                  dateWidth: "formGroup_datepicker-custom-form-input33",
                  value: props.inputs.stockInDt ? props.inputs.stockInDt : "",
                  onChange: (e) => {
                    let { value } = { ...e.target };
                    props.setInputs({
                      ...props.inputs,
                      stockInDt: value,
                    });
                  },
                },
                {
                  type: "input",
                  name: "담당자",
                  inputClass: "input",
                  value: props.inputs.createId ? props.inputs.createId : "",
                  onChange: (e) => {
                    let { value } = { ...e.target };
                    props.setInputs({
                      ...props.inputs,
                      createId: value,
                    });
                  },
                  readOnly: true,
                },
                {
                  type: "input",
                  name: "입고창고",
                  inputClass: "input",
                  value: props.inputs.inWh ? props.inputs.inWh : "",
                  onChange: (e) => {
                    let { value } = { ...e.target };
                    props.setInputs({
                      ...props.inputs,
                      inWh: value,
                    });
                  },
                },
                {
                  type: "input",
                  name: "진행상태",
                  inputClass: "input",
                  value: props.inputs.poStusNm ? props.inputs.poStusNm : "",
                  onChange: (e) => {
                    let { value } = { ...e.target };
                    props.setInputs({
                      ...props.inputs,
                      poStusNm: value,
                    });
                  },
                },
              ]}
            />
          </Card>
          <Section /> */}
                {/* </div> */}
                <div>
                    <Section />
                    <Card
                        wrapStyle={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                        }}
                    >
                        <AuthGroupButton
                            pageName="PM10030"
                            target="F01"
                            refreshNone="none"
                            // refreshFunc={() => {
                            //   props.Reset();
                            //   props.setSelectedRowData([]);
                            // }}
                            addFunc={() => {
                                //props.Reset();
                                props.setSelectedRowData([]);
                            }}
                            saveFunc={() => props.SaveConfirm('save')}
                            deleteFunc={() => {
                                props.DeleteConfirm();
                            }}
                        />
                    </Card>
                    <Section />
                    <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '370px' }}>
                        <AgGridReact
                            ref={gridRef1}
                            animateRows={true}
                            columnDefs={columnDefs1}
                            groupIncludeTotalFooter={true}
                            defaultColDef={{
                                flex: 1,
                                editable: false,
                                resizable: true,
                                sortable: true,
                                filter: true,
                                floatingFilter: true,
                            }}
                            frameworkComponents={{
                                customHeaderRenderer: Commons.CustomHeaderRenderer,
                            }}
                            onCellValueChanged={(e) => {
                                let rowIndex = e.rowIndex;
                                GridFunctions.onCellValueChanged(e, gridRef1, props.setChangedRowData);
                                props.rowData1.map((item, index) => {
                                    if (index.itemCd === e.data.itemCd) {
                                        item.inItemAmt = e.data.inQty * e.data.inItemCost;
                                        item.inItemVat = item.itemVatYn === 'Y' ? e.data.inItemCost * 0.1 : 0;
                                    }
                                });
                                props.setChangedRowData((current) => [...current]);
                            }}
                            rowData={props.rowData1}
                            rowSelection="multiple"
                            onSelectionChanged={() =>
                                GridFunctions.onSelectionChanged(gridRef1, props.setSelectedRowData)
                            }
                            // getRowStyle={(e) => GridFunctions.getRowStyle(e)}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PM10030;
